import type { components } from 'admination-react/api-schema'
import { fillPath, getJson, sendJson } from '@/core/api/http'
import { isAufnahmePotenzialanalyse } from './aufnahmePotenzialanalyse'

type Schemas = components['schemas']

export type Bogen = 'jobcoach' | 'anleiter' | 'sprachlehrkraft'

export type Bewertungsbogen = Schemas['BewertungsbogenStandResult']

export type BewertungsbogenGespeichert = Schemas['BewertungsbogenSpeichernResult']

export type Ausgefuellt = Schemas['Ausgefuellt']

const MALFORMED_RESPONSE = 'Die Antwort des Servers hatte nicht die erwartete Form.'

function isRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value)
}

function isAusgefuellt(value: unknown): value is Ausgefuellt {
  return (
    isRecord(value) &&
    (value.von === null || typeof value.von === 'string') &&
    typeof value.am === 'string' &&
    !Number.isNaN(Date.parse(value.am))
  )
}

export async function getBewertungsbogen(coachingId: string, bogen: Bogen): Promise<Bewertungsbogen> {
  const body = await getJson<unknown>(
    fillPath('/bewertungsbogen/{coaching_id}/{bogen}', { coaching_id: coachingId, bogen }),
  )
  if (!isAufnahmePotenzialanalyse(body)) throw new Error(MALFORMED_RESPONSE)
  const { ausgefuellt } = body as { ausgefuellt?: unknown }
  if (ausgefuellt !== null && !isAusgefuellt(ausgefuellt)) throw new Error(MALFORMED_RESPONSE)
  return { ...body, ausgefuellt } as Bewertungsbogen
}

function isGespeichert(body: unknown): body is BewertungsbogenGespeichert {
  return (
    isRecord(body) &&
    typeof body.status === 'string' &&
    typeof body.aufgabe === 'string' &&
    isAusgefuellt(body.ausgefuellt)
  )
}

export async function saveBewertungsbogen(
  coachingId: string,
  bogen: Bogen,
  werte: Record<string, unknown>,
): Promise<BewertungsbogenGespeichert> {
  const path = fillPath('/bewertungsbogen/{coaching_id}/{bogen}', { coaching_id: coachingId, bogen })
  const body = await sendJson<unknown>(path, 'POST', { werte } satisfies Schemas['VorschauRequest'])
  if (!isGespeichert(body)) throw new Error(MALFORMED_RESPONSE)
  return body
}
